<template>
    <page-main>
        <div class="container">
            <div class="page-border">
                <div class="row">
                    <div class="col-md col-sm-6">
                        <form-input v-model="query.syear" id="syear" label="學年度" type="number"></form-input>
                    </div>
                    <div class="col-md col-sm-6">
                        <form-select v-model="query.semester" id="semester" label="學期">
                            <div is="option" value="">全部</div>
                            <div is="option" value="u">上</div>
                            <div is="option" value="d">下</div>
                        </form-select>
                    </div>
                    <div class="col-md col-sm-12">
                        <form-date-input v-model="query.date" id="date" label="日期"></form-date-input>
                    </div>
                    <div class="col-md col-sm-6">
                        <form-select v-model="query.attend" id="attend" label="出席情形">
                            <div is="option" value="">全部</div>
                            <div is="option" value="y">正常</div>
                            <div is="option" value="n">缺席</div>
                        </form-select>
                    </div>
                    <div class="col-md col-sm-12">
                        <form-input v-model="query.keyword" id="keyword" label="關鍵字" type="text" placeholder="教師編號、教師姓名"></form-input>
                    </div>
                    <div class="col-md-12 col-sm-12">
                        <btn-group :load="reload" :insert="insert" :del="del" :deleteItems="deleteItem.length"></btn-group>
                    </div>
                </div>
            </div>
            <div class="page-border">
                <table class="table">
                    <thead>
                        <tr>
                            <th style="width:30px;"></th>
                            <th>學年度-學期</th>
                            <th>日期</th>
                            <th>教師編號-教師姓名</th>
                            <th>出席情形</th>
                        </tr>
                    </thead>
                    <tr v-for="item in tableData.value" :key="item.MorningmeetingTeacherID">
                        <td data-th="選擇"><input type="checkbox" v-model="deleteItem" :value="item.MorningmeetingTeacherID" /></td>
                        <td data-th="學年度-學期">{{item.SYear}}-{{item.Semester|semester}}</td>
                        <td data-th="日期">{{item.Date|date('yyyy/mm/dd')}}</td>
                        <td data-th="教師編號-教師姓名"><b-button size="sm" variant="link" @click="edit(item.MorningmeetingTeacherID)">{{item.TeacherNo}}-{{item.TeacherName}}</b-button></td>
                        <td data-th="出席情形">{{item.Attend|attend}}</td>
                    </tr>
                </table>
                <pagination v-model="pager" :rows="tableData.count" :rowperpage="10" @paging="load"></pagination>
            </div>
        </div>
        <Detail id="info" :modalkey="modalkey" @reload="reload" @edit="edit"></Detail>
    </page-main>
</template>

<script>
    import Detail from './morningmeetingTeacherDetail.vue';
    import { master } from '@/views';
    export default master({
        name: 'morningmeetingTeacher',
        api: '/api/morningmeetingteacher/',
        components: { Detail },
        filters: {
            attend: function (value) {
                switch (value) {
                    case "y": return "正常";
                    case "n": return "缺席";
                    default: return "";
                }
            },
        }
    });
</script>

<style>
</style>